import { render, staticRenderFns } from "./ct-area.vue?vue&type=template&id=4b25ece4&scoped=true"
import script from "./ct-area.vue?vue&type=script&lang=js"
export * from "./ct-area.vue?vue&type=script&lang=js"
import style0 from "./ct-area.vue?vue&type=style&index=0&id=4b25ece4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b25ece4",
  null
  
)

export default component.exports